import React from 'react';
import MessageItem from './MessageItem';

const AnimatedMessageList = ({ messages, onClose }) => {
  return (
    <div className="space-y-3">
      {messages.map((message, index) => (
        <div
          key={message.id}
          className={`
            transform transition-all duration-300 ease-out
            ${message.isLeaving 
              ? 'translate-y-0 opacity-0 scale-95 max-h-0 overflow-hidden' 
              : 'translate-y-0 opacity-100 scale-100 max-h-96'
            }
          `}
          style={{
            // 进入动画延迟
            transitionDelay: message.isLeaving ? '0ms' : `${index * 50}ms`,
            // 高度动画
            transitionProperty: 'transform, opacity, max-height',
            // 消失时的间距动画
            marginBottom: message.isLeaving ? '0px' : '12px'
          }}
        >
          <MessageItem
            message={message}
            onClose={onClose}
          />
        </div>
      ))}
    </div>
  );
};

export default AnimatedMessageList;
